import { useEffect } from 'react'
import { NavLink } from 'react-router-dom'
import { useAuthUser } from './auth/auth.ts'
import { installSyncListeners } from './data/sync.ts'
import { AppRoutes } from './routes'

export default function App() {
  const { user } = useAuthUser()

  useEffect(() => {
    installSyncListeners()
  }, [])

  const navItems = [
    { to: '/', label: 'Home', end: true },
    { to: '/drill', label: 'Drill' },
    { to: '/exam', label: 'Exam block' },
    { to: '/stats', label: 'Stats' },
    ...(user
      ? [{ to: '/profile', label: 'Profile' }]
      : [{ to: '/login', label: 'Login/Register' }]),
    { to: '/preview', label: 'Preview' },
  ]

  return (
    <div className="app-shell">
      <header className="app-header">
        <span className="app-title">dMAT Core Module Practice</span>
        <nav className="app-nav" aria-label="Main navigation">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
      </header>
      <main className="app-main">
        <AppRoutes />
      </main>
    </div>
  )
}
